import { Directive, Input, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';
import { TenantModuleType } from '../models/tenantModuleType';
import { Subscription } from 'rxjs';
@Directive({
  selector: '[allowModule]',
  standalone: false
})
export class AllowModuleDirective implements OnInit, OnDestroy {
  @Input() allowModule: TenantModuleType;
  private subscription: Subscription;

  constructor(
    private elementRef: ElementRef,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit() {
    this.subscription = this.appConfigService.tenant$.subscribe((tenant) => {
      if (tenant) {
        let hasModule = tenant.modules.some((module) => module.moduleType === this.allowModule);
        if (!hasModule) {
          //Set style to handle items that are generated outside of the DOM (ex. mat-menu items)
          this.elementRef.nativeElement.style.display = 'none';
          this.elementRef.nativeElement.remove();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
